export const enum ImportedFileStatus {
	ORIGINAL = 'original',
	CHECKED = 'checked',
	FINISHED = 'finished',
	VALIDATED = 'validated',
}
